import { Static, Type } from '@sinclair/typebox'
import { FlowRun } from '../../flow-run/flow-run'
import { PopulatedFlow } from '../../flows/flow'

export const AdminExecution = Type.Object({
    id: Type.String(),
    tenantId: Type.String(),
    flowDisplayName: Type.Union([Type.String(), Type.Null()]),
    status: Type.String(),
    startTime: Type.Union([Type.String(), Type.Null()]),
    flowId: Type.String(),
    externalId: Type.Union([Type.String(), Type.Null()]),
    externalCustomerId: Type.Union([Type.String(), Type.Null()]),
})

export type AdminExecution = Static<typeof AdminExecution>

export const AdminExecutionDetail = Type.Object({
    run: Type.Omit(FlowRun, ['terminationReason', 'pauseMetadata']),
    flow: PopulatedFlow,
})

export type AdminExecutionDetail = {
    run: Omit<FlowRun, 'terminationReason' | 'pauseMetadata'>
    flow: PopulatedFlow
}

export const ListAdminExecutionsRequest = Type.Object({
    cursor: Type.Optional(Type.String()),
    limit: Type.Optional(Type.Number({ default: 20 })),
    search: Type.Optional(Type.String()),
    status: Type.Optional(Type.Array(Type.String())),
    externalId: Type.Optional(Type.String()),
    externalCustomerId: Type.Optional(Type.String()),
    tenantId: Type.Optional(Type.String()),
    userId: Type.Optional(Type.String()),
    startTimeAfter: Type.Optional(Type.String()),
    startTimeBefore: Type.Optional(Type.String()),
})

export type ListAdminExecutionsRequest = Static<
  typeof ListAdminExecutionsRequest
>
